import { Grid, Paper, Box, Stack, Typography, IconButton } from "@mui/material";
import React, { useState } from "react";
import Controls from "../controls/Controls";
import CloseIcon from "@mui/icons-material/Close";
import { AddBoxRounded } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const devStatus = [
  { id: "fixed", title: "Fixed" },
  { id: "pending", title: "Review" },
];
const notifyStatus = [
  { id: "notified", title: "Notified" },
  { id: "pending", title: "Notify" },
];
const ticketStatus = [
  { id: "close", title: "Closed" },
  { id: "pending", title: "Review" },
];

const filterValues = {
  ticketId: "",
  clientId: "",
  application: "",
  issue: "",
  user: "",
  devOps: "",
  notify: "",
  ticket: ""
}

export default function SearchPanel({ setOpen, handleSearch, handleFilterReset }) {

  const [filterData, setFilterData] = useState(filterValues);

  const handleOnChange = ({ target }) => {
    const data = { ...filterData };
    data[target.name] = target.value;
    setFilterData(data);
  }

  const handleSubmit = () => {
    handleSearch(filterData);
  }

  const handleReset = () => {
    setFilterData(filterValues);
    handleFilterReset();
  }

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Typography variant="h6">Filters</Typography>
        </Grid>
        <Grid item xs={6}>
          <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
            <IconButton
              color="error"
              component="button"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Controls.Input
            name="ticketId"
            label="Ticket ID"
            type="number"
            value={filterData?.ticketId}
            onChange={handleOnChange}
          />
        </Grid>

        {/* <Grid item xs={4}>
          <Controls.Input
            name="clientId"
            label="Customer ID"
            value={filterData?.clientId}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={4}>
          <Controls.Input
            name="application"
            label="Application"
            value={filterData?.application}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            name="issue"
            label="Issue"
            value={filterData?.issue}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            name="user"
            label="User"
            value={filterData?.user}
            onChange={handleOnChange}
          />
        </Grid> */}
        <Grid item xs={3}>
          <Controls.Select
            name="devOps"
            label="Issue Status"
            option={devStatus}
            value={filterData?.devOps}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={3}>
          <Controls.Select
            name="notify"
            label="Notify Status"
            option={notifyStatus}
            value={filterData?.notify}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={3}>
          <Controls.Select
            name="ticket"
            label="Ticket Status"
            option={ticketStatus}
            value={filterData?.ticket}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >

            <Controls.Button
              
              text="Reset"
              size="small"
              variant="outlined"
              startIcon={<RestartAltIcon />}
              onClick={handleReset}
              sx={{
                width:"80px",
                textTransform: 'none',
                color: 'black',
                border: "1px solid black",
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white',

                }
              }}
            />
            <Controls.Button
              text="Search"
              size="small"
              variant="outlined"
              startIcon={<SearchIcon />}
              onClick={handleSubmit}
              sx={{
                width:"80px",
                textTransform: 'none',
                color: 'black',
                border: "1px solid black",
                '&:hover': {
                  backgroundColor: 'black',
                  color: 'white',

                }
              }}
            />
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}
